import { showNotification as showNotificationAction } from 'react-admin';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import EmailIcon from '@material-ui/icons/EmailOutlined';
import Tooltip from '@material-ui/core/Tooltip';

class CreateToursEmailButton extends Component {
  handleClick = () => {
    const fetchURL = process.env.REACT_APP_DRAFTEMAIL_URL
    const { push, selectedIds, showNotification } = this.props;
    const token = localStorage.getItem('token');
    const hdrs = new Headers({
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token,
    })
    var payload = new Object();
    payload.type = "Tours";
    payload.ids  = selectedIds;
    const bdy = JSON.stringify(payload);    
    fetch(fetchURL, { method: 'POST', body: bdy, headers: hdrs })
      .then(response => {
        if (response.ok) {
          response.json().then(json => {
            // console.log(response, json);
            if (json != "") {
              showNotification("Email generated");
              push('/TourDetails');

            } else {
              showNotification("Email generated");
              push('/TourDetails');
            }
          });
        } else if (response.status === '401' ) {
          showNotification("Unauthorized, please login...");
        } else {
          response.json().then(json => {
            // console.log(response, json);
            if (json != "") {
              showNotification("Unable to generate for " + json.message);

            } else {
              showNotification("Error generating Email(s)");
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
        showNotification('Error: generating Tours email', 'warning')
      });
  }

  render() {
    return <div><Tooltip title="Tours Email"><IconButton color="primary" component="span" onClick={this.handleClick}>
      <EmailIcon />
    </IconButton></Tooltip></div>
  }
}

CreateToursEmailButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func,
};
export default connect(null, {
  showNotification: showNotificationAction,
  push: pushAction,
})(CreateToursEmailButton);
